// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var DOM__FocusTrail$SmartcutsMacros = require("./DOM__FocusTrail.bs.js");

function t_encode(v) {
  return Js_dict.fromArray([[
                "focusedElement",
                Decco.optionToJson(Selector$SmartcutsMacros.selector_encode, v.focusedElement)
              ]]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var focusedElement = Decco.optionFromJson(Selector$SmartcutsMacros.selector_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "focusedElement"), null));
  if (focusedElement.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              focusedElement: focusedElement._0
            }
          };
  }
  var e = focusedElement._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".focusedElement" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function isRelevantCommandFocusPrecondition(htmlElement) {
  var _otherTagName = htmlElement.tagName;
  switch (_otherTagName) {
    case "INPUT" :
        var match = htmlElement.type;
        switch (match) {
          case "date" :
          case "datetime-local" :
          case "email" :
          case "month" :
          case "number" :
          case "password" :
          case "search" :
          case "tel" :
          case "text" :
          case "time" :
          case "url" :
          case "week" :
              return true;
          default:
            return false;
        }
    case "TEXTAREA" :
        return true;
    default:
      return htmlElement.isContentEditable;
  }
}

function maybeFromFocusedHtmlElement(htmlElement) {
  if (isRelevantCommandFocusPrecondition(htmlElement)) {
    return {
            focusedElement: Selector$SmartcutsMacros.forDomElement(htmlElement)
          };
  }
  
}

function maybeFromDomEventAndFocusTrail(focusTrail, domEvent) {
  if (domEvent.TAG !== /* MouseEvent */0) {
    return ;
  }
  if (domEvent._0 !== "click") {
    return ;
  }
  var func = function (param, param$1) {
    return DOM__FocusTrail$SmartcutsMacros.getFocusedElementJustBeforeClickEvent(150, param, param$1);
  };
  return Belt_Option.flatMap(Curry._2(func, domEvent._1, focusTrail), maybeFromFocusedHtmlElement);
}

exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.maybeFromDomEventAndFocusTrail = maybeFromDomEventAndFocusTrail;
/* Selector-SmartcutsMacros Not a pure module */
